import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './CustomerSettingsField.module.scss';

const CustomerSettingsField: React.FC = () => {
	const { localizationData } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<div className={style.container}>
			<Text
				className={style.heading}
				translationNameSpace="localizationSettings"
				translationKey="useCustomerSettingsLabel"
				theme="secondary"
				size="l"
				weight="bold"
			/>
			<div className={style.field}>
				<svg className={style.icon}>
					<use
						xlinkHref={`${breadcrumbs}${
							localizationData?.useCustomerSettings ? '#checkMark' : '#crossMark'
						}`}
					/>
				</svg>
				<Text
					translationNameSpace="localizationSettings"
					translationKey="useCustomerSettingsLabel"
					asFragment={true}
				/>
			</div>
		</div>
	);
};

export default CustomerSettingsField;
